<script lang="ts">
	import { Alert, Container, LabelList, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { formatTime, formatDays } from '../helpers/cury_format';
	import { getSlotIcon } from '../helpers/cury_icons';

	export let vialColorSlot: { left: string; right: string };
	export let profile: any;
</script>

<Container padding="s" class="mb-s">
	<Text styleType="h2" class="mb-s">
		{$format('label_days', { default: 'Days' })}
	</Text>
	<Text styleType="controls-small" class="text-bold">
		{$format('schedule_execute_on', { default: 'Execute schedule on' })}
		<span class="d-inline-block text-primary text-link text-bold">
			{formatDays(profile.schedule.days)}
			<span class="text-white">;&nbsp</span>
		</span>
	</Text>

	<hr class="mt-l mb-l" />

	<Text element="span" styleType="h2">
		{$format('time', { default: 'Time' })}
	</Text>
	<div class="mt-s"></div>
	<Text styleType="controls-small" class="d-inline-block text-bold">
		{$format('schedule_execute_at', { default: 'Execute schedule at' })}
	</Text>

	{#each profile.schedule.hours as hourSlot}
		<span class="d-inline-block controls-small-styles text-bold text-primary">
			{formatTime(hourSlot.time)}
			<span class="text-white">;&nbsp</span>
		</span>
	{/each}

	<hr class="mt-l mb-l" />

	<Text styleType="h2" class="mb-s">
		{$format('action', { default: 'Action' })}
	</Text>
	<div class="mt-s"></div>

	{#each profile.schedule.hours as vialSlot, i}
		{@const isLast = i < profile.schedule.hours.length - 1}
		<LabelList
			size="s"
			class={isLast ? 'mb-s' : ''}
			scrollable={true}
			labelList={[
				{
					value: $format(`label_${vialSlot.slot}_vial`, {
						default: `${vialSlot.slot} vial`,
					}),
					icon: getSlotIcon(vialSlot.slot),
					iconColor: vialColorSlot[vialSlot.slot],
				},
				{
					value:
						$format(`scene_label_intensity_${vialSlot.slot}`, {
							default: `${vialSlot.slot} ${vialSlot.intensity}% intensity`,
						}) +
						' ' +
						vialSlot.intensity +
						'%',
					icon: 'fas fa-spray-can',
					iconColor: vialColorSlot[vialSlot.slot],
				},
				{
					value: formatTime(vialSlot.time),
					icon: 'fas fa-clock',
					type: 'secondary',
					iconColor: vialColorSlot[vialSlot.slot],
				},
			]}
		/>
	{/each}

	<Alert type="info" class="mt-s">
		<Text styleType="body-small">
			{$format('label_auto_switching_enabled', {
				default:
					'Auto-switching is automatically enabled. Device will switch to the other slot if the active vial is empty, expired, or non-genuine. Manual schedules and user automations are disabled while this profile is running.',
			})}
		</Text>
	</Alert>
</Container>
